const cache = new Map();
const inflight = new Map();

const TTL_MS = 5 * 60 * 1000;

export function cacheGet(key) {
  const entry = cache.get(key);
  if (!entry) return null;
  if (Date.now() - entry.ts > TTL_MS) {
    cache.delete(key);
    return null;
  }
  return entry.data;
}

export function cacheSet(key, data) {
  cache.set(key, { data, ts: Date.now() });
}

export function cacheKey(parts) {
  return JSON.stringify(parts);
}

function runFetch(key, fetcher, onUpdate) {
  const promise = Promise.resolve()
    .then(() => fetcher())
    .then((data) => {
      cacheSet(key, data);
      onUpdate?.(data);
      return data;
    })
    .finally(() => {
      inflight.delete(key);
    });

  inflight.set(key, promise);
  return promise;
}

/** Fetch with stale-while-revalidate: returns cached data immediately when available. */
export async function fetchCached(key, fetcher, { force = false, onUpdate } = {}) {
  if (!force) {
    const hit = cacheGet(key);
    if (hit !== null) {
      if (!inflight.has(key)) {
        runFetch(key, fetcher, onUpdate).catch(() => {});
      }
      return hit;
    }
  }

  if (inflight.has(key)) {
    return inflight.get(key);
  }

  return runFetch(key, fetcher, onUpdate);
}

export function cacheClear() {
  cache.clear();
  inflight.clear();
}

export function prefetch(key, fetcher) {
  if (cacheGet(key) !== null || inflight.has(key)) return;
  runFetch(key, fetcher).catch(() => {});
}
